import { lazy } from 'react';
import { NOMAD_LIFE_MERCHANT } from '@root/constants/paths';
import { getNomadLifeContentData } from '@root/constants/formData';
import { getNomadLifeVerifyRoutes } from './nomadLifeVerifyRoutes';
import { getNomadLifePayRoutes } from './nomadLifePayRoutes';

const Layout = lazy(() => import('@pages/nomadlife/Layout'));

const { header } = getNomadLifeContentData();

export const nomadLifeRoutes = {
  path: NOMAD_LIFE_MERCHANT,
  element: <Layout headerContent={header} />,
  children: [...getNomadLifeVerifyRoutes(), ...getNomadLifePayRoutes()]
};
